import { useEffect, useState } from 'react'
import {
  collection,
  query,
  where,
  getDocs
} from 'firebase/firestore'
import { db } from '@/firebase'
import type { SubscriptionTopic } from '@smorgrav/hundehall_shared'

interface SubscriberInfo {
  uid: string
  email: string
  name: string
}

const useSubscribers = (topic: SubscriptionTopic | null) => {
  const [subscribers, setSubscribers] = useState<SubscriberInfo[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!topic) {
      setSubscribers([])
      return
    }

    let cancelled = false
    setLoading(true)

    const fetchSubscribers = async () => {
      const q = query(
        collection(db, 'subscriptions'),
        where('topics', 'array-contains', topic)
      )
      const snap = await getDocs(q)
      if (cancelled) return

      const results: SubscriberInfo[] = snap.docs.map((doc) => {
        const data = doc.data()
        return {
          uid: data.uid || doc.id,
          email: data.email || '',
          name: data.name || ''
        }
      })
      setSubscribers(results)
      setLoading(false)
    }

    fetchSubscribers().catch((err) => {
      console.error('Failed to fetch subscribers', err)
      if (!cancelled) setLoading(false)
    })

    return () => {
      cancelled = true
    }
  }, [topic])

  return { subscribers, loading }
}

export { useSubscribers }
export type { SubscriberInfo }
